var View = require('views/base/view');
import IconLoadService from 'services/icon-load-service';
/*
Use:
      this.renderAlert(
        'error', << alert type will add this to the alert container as a class for style overrides
        'alert title',
        'alert body text. For accessibility, include an id in the text and be clear what the user is to do for next steps',
        'alert-icon fas icon-for-alert'  << icon class name
        );
*/

var AlertView = View.extend({
  template: require('./templates/alert'),
  autoRender: true,
  className: 'alert-container',
  initialize: function () {
    this.model.set("cid", this.model.cid);
    IconLoadService.applyIcon("fal fa-times", this.model.get("cid"), "fa-lg");
  },
  attach: function() {
    this.delegate('click', '.alert-close', function() {
      Chaplin.mediator.publish('alert:close');
    });
    View.prototype.attach.apply(this, arguments);
  }
});

module.exports = AlertView;